import { useState } from "react";
import {
  Stack,
  Typography,
  Divider,
  useTheme,
  IconButton,
  Collapse,
} from "@mui/material";
import { Icon } from "@iconify/react";

import { RHFCheckbox } from "@app/components";
import { Strings } from "@app/constants";

import { FuelsFiltersProps } from "../../types";

const FuelFilter = ({ fuels }: FuelsFiltersProps) => {
  const theme = useTheme();
  const [drawerOpen, setDrawerOpen] = useState(true);
  return (
    <Stack sx={{ py: 1 }}>
      <Stack
        flexDirection={"row"}
        justifyContent={"space-between"}
        onClick={() => setDrawerOpen(!drawerOpen)}
      >
        <Typography variant="subtitle1">{Strings.filters.fuelType}</Typography>
        <IconButton size="small">
          {drawerOpen ? (
            <Icon icon="mdi:chevron-up" width={20} height={20} />
          ) : (
            <Icon icon="mdi:chevron-down" width={20} height={20} />
          )}
        </IconButton>
      </Stack>
      <Collapse in={drawerOpen}>
        {fuels?.map((fuel) => (
          <>
            <RHFCheckbox
              key={fuel}
              name="fuel"
              value={fuel}
              label={fuel}
              sx={{ "&.Mui-checked": { color: theme.palette.primary.main } }}
            />
            <Divider />
          </>
        ))}
      </Collapse>
    </Stack>
  );
};

export { FuelFilter };
